<template>
  <div class="container">
    <div class="row _margin-top-40">
      <div class="col-md-offset-3 col-md-6">
        <div class="card" v-if="!error">
          <h6>Payment Successful</h6>
          <hr />
          <div class="text-center">
            <div class="tick-container">
              <div class="tick"></div>
            </div>
          </div>
          <h4>Congratulations. You have just offset your Carbon Footprint for one year.</h4>

          <p>
            If you provided an email address, you shall receive your carbon balancing certificate by email from C- Level
            within the next 24hrs.
          </p>
          <p>
            Should you want to find out more regarding your offset or want to amend any details, please contact C- level
            directly quoting your reference <span class="badge">{{ oid }}</span>
          </p>
        </div>

        <div class="card" v-else>
          <h6>Payment Failed</h6>
          <hr />
          <h4>Oops!</h4>
          <p>It looks like your payment has failed. Let's try that again.</p>

          <uiv-btn type="button" @click="onTryAgain">Try Again</uiv-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'CarbonOffsetProcess',
  data() {
    return {
      error: '',
      oid: ''
    }
  },
  async mounted() {
    await this.$store.dispatch('token/getToken');
    this.$store.dispatch('page_loader/start', 0);
    this.error = this.$route.query.c;
    this.oid = this.$route.query.oid;
    await this.$store.dispatch('carbon_offset/processPayment', this.$route.query);
    this.$store.dispatch('page_loader/stop');
  },
  computed: {
    ...mapState({
      carbonOffsetEquivalent: ({ carbon_offset }) => carbon_offset.equivalent
    })
  },
  methods: {
    async onTryAgain() {
      this.$store.dispatch('tracing/addAction', { name: 'Page', value: 'Carbon Offset Process' });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Try Again' });
      await this.$store.dispatch('tracing/saveActions');
      this.$router.push({ name: 'carbonOffset' });
    }
  }
};
</script>

<style lang="scss" scoped>
.tick-container {
  position: relative;
  width: 100px;
  height: 100px;
  background-color: darken($brand-colour-primary, 10%);
  border-radius: 50%;
  display: inline-block;

  .tick {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 32px;
    height: 24px;
    background: url('../../assets/tick.png') no-repeat;
    background-size: contain;
    background-position: 100% 0;
  }
}
</style>
